import { render, staticRenderFns } from "./RecycleList.vue?vue&type=template&id=42392188&scoped=true"
import script from "./RecycleList.vue?vue&type=script&lang=js"
export * from "./RecycleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42392188",
  null
  
)

export default component.exports